import { useEffect } from "react";
import { PostpaidHistory } from "./PostpaidHistory"
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import UtilityPageLayout from "../../component/layout/UtilityPageLayout";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";
import { useFeatureFlag } from "../../../../tenant/features/useFeatureFlag";

export const PostpaidPage = () => {
    const { updateLayout } = useConfigLayout();
    const postpaidHistoryEnabled = useFeatureFlag(FeatureFlagName.ADMIN_POSTPAID_HISTORY);

    useEffect(() => {
            updateLayout({
                showCountrySelector: false,
                utility: null,
                // Nothing to export while the feature is locked.
                showExportButton: postpaidHistoryEnabled,
                showBreadCrumb: false,
            });
        }, [updateLayout, postpaidHistoryEnabled]);

    return (
        <>
            <UtilityPageLayout title="Postpaid History" feature={FeatureFlagName.ADMIN_POSTPAID_HISTORY}>
                <PostpaidHistory/>
            </UtilityPageLayout>
        </>
    );
}